import { css } from "@repo/styled-system/css";
import type { BookingStatus } from "./status";

/**
 * STATIC per-status Panda classes. Panda extracts CSS from LITERAL `css(...)` calls, so the six
 * status colours are spelled out here (one literal per status) rather than built from a computed
 * token string — that guarantees the `@repo/theme` `booking.*` variables actually render. The
 * label + shape carry meaning independently (status.ts), so colour is always redundant.
 */

export const statusBadgeClass: Record<BookingStatus, string> = {
  PENDING: css({
    bg: "booking.pending.bg",
    color: "booking.pending.fg",
    borderColor: "booking.pending.border",
  }),
  CONFIRMED: css({
    bg: "booking.confirmed.bg",
    color: "booking.confirmed.fg",
    borderColor: "booking.confirmed.border",
  }),
  SEATED: css({
    bg: "booking.seated.bg",
    color: "booking.seated.fg",
    borderColor: "booking.seated.border",
  }),
  COMPLETED: css({
    bg: "booking.completed.bg",
    color: "booking.completed.fg",
    borderColor: "booking.completed.border",
  }),
  NO_SHOW: css({
    bg: "booking.noShow.bg",
    color: "booking.noShow.fg",
    borderColor: "booking.noShow.border",
  }),
  CANCELLED: css({
    bg: "booking.cancelled.bg",
    color: "booking.cancelled.fg",
    borderColor: "booking.cancelled.border",
  }),
};

export const statusDotClass: Record<BookingStatus, string> = {
  PENDING: css({ color: "booking.pending.solid" }),
  CONFIRMED: css({ color: "booking.confirmed.solid" }),
  SEATED: css({ color: "booking.seated.solid" }),
  COMPLETED: css({ color: "booking.completed.solid" }),
  NO_SHOW: css({ color: "booking.noShow.solid" }),
  CANCELLED: css({ color: "booking.cancelled.solid" }),
};

/** Background tint classes for the timeline blocks (bg + border, readable label on top). */
export const statusTintClass: Record<BookingStatus, string> = {
  PENDING: css({ bg: "booking.pending.bg", borderColor: "booking.pending.solid" }),
  CONFIRMED: css({ bg: "booking.confirmed.bg", borderColor: "booking.confirmed.solid" }),
  SEATED: css({ bg: "booking.seated.bg", borderColor: "booking.seated.solid" }),
  COMPLETED: css({ bg: "booking.completed.bg", borderColor: "booking.completed.solid" }),
  NO_SHOW: css({ bg: "booking.noShow.bg", borderColor: "booking.noShow.solid" }),
  CANCELLED: css({ bg: "booking.cancelled.bg", borderColor: "booking.cancelled.solid" }),
};
